import type { WidgetEventPayload } from "@/types";

export const trackWidgetEvent = (
  payload: Omit<WidgetEventPayload, "event">,
) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "telekomId_widget_event",
      ...payload,
      host: payload.host ?? window.location.host,
      path: payload.path ?? window.location.pathname,
    });
  } catch (e) {
    console.warn(e);
  }
};
